<ion-content>
  <div *ngIf="msRegistrationForm.firstName$ | async" class="wrapper-form">
    <div class="ms-content">
      <div class="image-container">
        <img class="logo" src="../../../assets/icon/ms_logo.png" />
      </div>
      <div class="ms-heading">M&S Bonus card - Διαχείριση προφίλ</div>
      <ion-qc-person-details-form
        [personDetails]="msRegistrationForm.msRegistrationForm"
      ></ion-qc-person-details-form>
    </div>
    <ion-button [disabled]="PersonFacade.formIsValid" (click)="register()"
      >Υποβολή/Register</ion-button
    >
    <p>*Η συμπλήρωση των πεδίων είναι υποχρεωτική.</p>

    <p>
      Για οποιοδήποτε πρόβλημα με την επικαιροποίηση των στοιχείων σας, στείλτε
      μας email στο
      <a href="mailto: gr.dataprivacy@marks-and-spencer.com">
        gr.dataprivacy&#64;marks-and-spencer.com</a
      >
    </p>

    <p>
      Δείτε αναλυτικά τους όρους του προγράμματος
      <a
        href="https://bonuscard.marksandspencer.gr/Terms.aspx"
        target="”_blank”"
        >εδώ.</a
      >
    </p>
  </div>
  <div class="textInfo"></div>
</ion-content>
